import LoginPage from './components/LoginPage'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  }
]

export default routes